class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      let sectionElement;
      
      if (section.id === 'cart-drawer') {
        sectionElement = document.querySelector(section.selector);
      } else if (section.id === 'cart-icon-bubble') {
        sectionElement = document.getElementById(section.id);
      } else {
        const containerElement = document.getElementById(section.id);
        if (containerElement) {
          sectionElement = containerElement.querySelector(section.selector) || containerElement;
        }
      }

      const sectionData = parsedState.sections[section.section || section.id];
      if (!sectionElement || !sectionData) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(sectionData, section.selector);
    });

    if (parsedState.sections) {
      const mainCartItemsSection = document.querySelector('.main-cart-items-section');
      if (mainCartItemsSection) {
        const sectionKey = mainCartItemsSection.id.replace('shopify-section-', '');
        if (parsedState.sections[sectionKey]) {
          const html = new DOMParser().parseFromString(parsedState.sections[sectionKey], 'text/html');
          const newSection = html.getElementById(mainCartItemsSection.id);
          if (newSection) {
            mainCartItemsSection.outerHTML = newSection.outerHTML;
            setTimeout(() => {
              document.querySelectorAll('quantity-input').forEach(el => el.validateQtyRules?.());
            }, 10);
          }
        }
      }
      
      const mainCartFooterSection = document.querySelector('.cart__footer-wrapper');
      if (mainCartFooterSection) {
        const sectionKey = mainCartFooterSection.id.replace('shopify-section-', '');
        if (parsedState.sections[sectionKey]) {
          const html = new DOMParser().parseFromString(parsedState.sections[sectionKey], 'text/html');
          const newFooterSection = html.getElementById(mainCartFooterSection.id);
          if (newFooterSection) {
            mainCartFooterSection.outerHTML = newFooterSection.outerHTML;
          }
        }
      }
    }

    if (window.initRecommendedProductsScript) {
      setTimeout(() => {
        window.initRecommendedProductsScript();
      }, 50);
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-drawer',
        selector: '.drawer__inner-wrapper',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];

    if (document.querySelector('cart-items')) {
      // Добавляем main-cart секции с динамическими ID
      const mainCartItemsSection = document.querySelector('.main-cart-items-section');
      const mainCartFooterSection = document.querySelector('.cart__footer-wrapper');
      
      if (mainCartItemsSection && mainCartItemsSection.id) {
        const sectionId = mainCartItemsSection.id.replace('shopify-section-', '');
        sections.push({
          id: sectionId,
          section: sectionId,
          selector: '.main-cart__container',
        });
      }
      
      if (mainCartFooterSection && mainCartFooterSection.id) {
        const sectionId = mainCartFooterSection.id.replace('shopify-section-', '');
        sections.push({
          id: sectionId,
          section: sectionId,
          selector: '.cart__footer-wrapper',
        });
      }
    }

    return sections;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.drawer__inner-wrapper',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];

    if (document.querySelector('cart-items')) {
      // Добавляем main-cart секции с динамическими ID
      const mainCartItemsSection = document.querySelector('.main-cart-items-section');
      const mainCartFooterSection = document.querySelector('.cart__footer-wrapper');
      
      if (mainCartItemsSection && mainCartItemsSection.id) {
        const sectionId = mainCartItemsSection.id.replace('shopify-section-', '');
        sections.push({
          id: sectionId,
          section: sectionId,
          selector: '.main-cart__container',
        });
      }
      
      if (mainCartFooterSection && mainCartFooterSection.id) {
        const sectionId = mainCartFooterSection.id.replace('shopify-section-', '');
        sections.push({
          id: sectionId,
          section: sectionId,
          selector: '.cart__footer-wrapper',
        });
      }
    }

    return sections;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
